import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface MyPublicProfileModel {
    wtbMapEmail: string;
    phone: string;
    websiteUrl: string;
    storeDescription: string;
}
export interface MyPublicProfileResult extends BaseModel {
    publicProfile: MyPublicProfileModel;
}

export interface UpdatePublicProfileApiParameter extends BaseModel {
    userName: string;
    customerId: string;
    wtbMapEmail: string;
    phone: string;
    websiteUrl: string;
    storeDescription: string;
}

import {
    ApiParameter,
    API_URL_CURRENT_FRAGMENT,
    get,
    patch,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";

export interface GetPublicProfileApiParameter extends ApiParameter {
    userName: string;
    customerId: string
}

export interface AddAccountApiParameter extends ApiParameter {
    account: Partial<MyPublicProfileResult>;
}

const accountsUrl = "api/v2/dana/myPublicProfile";

export async function getPublicProfile(parameter: GetPublicProfileApiParameter) {

    const account = await get<MyPublicProfileResult>(`${accountsUrl}`, parameter);
    return account;

}

export async function updatePublicProfile(account: UpdatePublicProfileApiParameter) {
    const accountId = API_URL_CURRENT_FRAGMENT;
    const updatedAccount = await patch<MyPublicProfileResult>(`${accountsUrl}/${accountId}`, account);
    return updatedAccount;
}

export async function updatePublicProfileWithResult(
    parameter: UpdatePublicProfileApiParameter,
): Promise<ServiceResult<MyPublicProfileResult>> {
    try {
        const updatedAccount = await updatePublicProfile(parameter);
        return {
            successful: true,
            result: updatedAccount,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}


